import React from 'react';
import { Layout, ButtonContainer, Button } from '@vwfs-bronson/bronson-react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { dashboardPagePath } from 'components/navigation/paths';

type OfflinePaymentButtonBarProps = {
    back: () => void;
    success?: boolean;
    sendEmail?: () => void;
};

export const OfflinePaymentButtonBar: React.FC<OfflinePaymentButtonBarProps> = ({ back, sendEmail, success }) => {
    const { t } = useTranslation('total-early-settlement');
    const history = useHistory();
    const backToDashboard = (): void => {
        history.push(dashboardPagePath());
    };
    return (
        <>
            <Layout.Item className={'u-text-center'} default="1/1" s="1/1">
                <ButtonContainer center>
                    <Button secondary onClick={back} testId="offlinePaymentBackButton" type="button">
                        {t('offline-payment.button.back')}
                    </Button>
                    <Button onClick={backToDashboard} testId="dashboardButton" type="button">
                        {t('offline-payment.button.dashboard')}
                    </Button>
                </ButtonContainer>
            </Layout.Item>
            <Layout.Item className={'u-text-center'} default="1/1" s="1/1">
                {!success && (
                    <Button
                        element="a"
                        link
                        onClick={e => {
                            e.preventDefault();
                            sendEmail && sendEmail();
                        }}
                        testId="offlinePaymentSendEmailButton"
                        icon="semantic-mail"
                        href="/send-email"
                    >
                        {t('offline-payment.link')}
                    </Button>
                )}
            </Layout.Item>
        </>
    );
};
